import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-qr-scanner',
  standalone: false,
  
  templateUrl: './qr-scanner.component.html',
  styleUrl: './qr-scanner.component.css'
})
export class QrScannerComponent {
  constructor(private router: Router) {}

  onScanSuccess(result: string) {
    // Navigate to chat after successful scan
    this.router.navigate(['/chat']);
  }
}
